module.exports = __webpack_public_path__ + "img/banner_left.00284653.png";